import React from "react";
import { Route } from "react-router-dom";
import { ForgotPasswordPage } from "../../../features/auth/forgot-password/pages/ForgotPasswordPage";
import { PasswordLinkSentPage } from "../../../features/auth/forgot-password/pages/PasswordLinkSentPage";
import ChangePasswordPage from "../../../features/auth/reset-password/ResetPasswordPage";
import AppDeepLinkPage from "../../../features/auth/view/AppDeepLinkPage";
import { DeleteAccountPage } from "../../../features/auth/delete-account";

export const passwordRoutes = (
  <>
    <Route
      path="/forgot-password"
      element={<ForgotPasswordPage />}
    />
    <Route
      path="/password-link-sent"
      element={<PasswordLinkSentPage />}
    />
    <Route
      path="/reset-password"
      element={<ChangePasswordPage />}
    />
    <Route
      path="/get-start"
      element={<AppDeepLinkPage />}
    />
    <Route
      path="/delete-account"
      element={<DeleteAccountPage />}
    />
  </>
);
